<template>
  <div class="find">
    <!-- Image by https://unsplash.com/@garciasaldana_ -->
    <div
      class="find_background parallax-window"
      data-parallax="scroll"
      style="background-image: url(images/find.jpg)"
      data-speed="0.8"
    ></div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="find_title text-center">Skontaktuj się w sprawie wycieczek</div>
        </div>
        <div v-show="success" class="col-12">
          <div class="find_title text-center">Zgłoszenie wysłano pomyślnie</div>
          <div class="text-center">
            <a class="send_again" @click="success = false">Wyślij ponownie</a>
          </div>
        </div>
        <div v-show="!success" class="col-12">
          <div class="find_form_container">
            <form
              id="find_form"
              class="find_form d-flex flex-md-row flex-column align-items-md-center align-items-start justify-content-md-between justify-content-start flex-wrap"
              @submit.prevent
            >
              <div class="find_item">
                <div>Imię i nazwisko:</div>
                <input
                  v-model="name"
                  type="text"
                  class="destination find_input"
                  required="required"
                  placeholder="Imię i nazwisko"
                />
              </div>
              <div class="find_item">
                <div>Numer telefonu lub email</div>
                <input
                  v-model="phoneNumberOrMail"
                  type="text"
                  class="destination find_input"
                  required="required"
                  placeholder="Email/Telefon"
                />
              </div>
              <div class="find_item">
                <div>Wycieczka</div>
                <select
                  v-model="tripId"
                  name="trip"
                  class="dropdown_item_select find_input"
                  required="required"
                >
                  <option :value="null">-</option>
                  <option v-for="trip in trips" :key="trip.id" :value="trip.id">
                    {{ trip.title }}
                  </option>
                </select>
              </div>
              <div class="find_item">
                <div>Liczba osób</div>
                <select
                  id="max_price"
                  v-model="peopleCount"
                  name="max_price"
                  class="dropdown_item_select find_input"
                >
                  <option :value="null">-</option>
                  <option v-for="number in 20" :key="number" :value="number">
                    {{ number }}
                  </option>
                </select>
              </div>
              <m-button class="find_button" :loading="sendingData" @click="sendReservation">
                Wyślij
              </m-button>
            </form>
          </div>
          <div v-if="loggedUser" class="text-center white-text" data-cy="manage-reservations">
            <router-link :to="{ name: 'reservations' }"> Zarządzaj rezerwacjami </router-link>
          </div>
          <div v-show="error" class="text-center white-text" data-cy="reservation-error">
            Wystąpił błąd, spróbuj jeszcze raz.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import cli from '@/http'
import { mapState } from 'vuex'

export default {
  name: 'TripContact',
  data() {
    return {
      trips: [],
      name: '',
      phoneNumberOrMail: '',
      tripId: null,
      peopleCount: null,
      sendingData: false,
      success: false,
      error: false,
    }
  },
  computed: {
    ...mapState(['loggedUser']),
  },
  async mounted() {
    await this.fetchTrips()
  },
  methods: {
    async fetchTrips() {
      const today = moment().format('YYYY-MM-DD')
      // TODO: bigger page size
      try {
        const resp = await cli.get(`/trips/?starts_after=${today}`)
        this.trips = resp.data.results
      } catch (err) {
        // pass
      }
    },
    async sendReservation() {
      this.error = false
      this.sendingData = true
      const data = {
        name: this.name,
        phone_number_or_mail: this.phoneNumberOrMail,
        count_of_people: this.peopleCount,
        trip: this.tripId,
      }
      try {
        const resp = await cli.post('/reservations/', data)
        this.name = ''
        this.phoneNumberOrMail = ''
        this.tripId = null
        this.peopleCount = null
        this.success = true
      } catch (err) {
        this.$notify({
          title: 'Rezerwacja',
          text: 'Wystąpił błąd. Spróbuj jeszcze raz.',
          type: 'error',
        })
        this.error = true
      } finally {
        this.sendingData = false
      }
    },
  },
}
</script>

<style scoped>
.find_button {
  background: #ef7e1a !important;
}
.find_button:hover {
  opacity: 1;
}

.find_input:hover {
  border: solid 2px #ef7e1a;
}
.find_input:focus {
  outline-color: #ef7e1a;
  border: solid 2px #ef7e1a;
}
.parallax-window {
  min-height: 298px;
}
.send_again {
  color: white !important;
  cursor: pointer;
}
.send_again:hover {
  text-decoration: underline !important;
}
.white-text {
  margin-top: 20px;
  color: white;
}
</style>
